import { DEFAULT_MUSIC_TRACK_ID, MUSIC_TRACKS, type MusicTrackId } from '@/config/music.config';

const MUSIC_ENABLED_STORAGE_KEY = 'capibara.audio.musicEnabled';
const MUSIC_TRACK_STORAGE_KEY = 'capibara.audio.musicTrackId';

export function readMusicEnabledPreference(): boolean {
  try {
    return window.localStorage.getItem(MUSIC_ENABLED_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function writeMusicEnabledPreference(enabled: boolean): void {
  try {
    window.localStorage.setItem(MUSIC_ENABLED_STORAGE_KEY, enabled ? 'true' : 'false');
  } catch {
    // localStorage can be unavailable in private mode; the in-memory store still works.
  }
}

export function readMusicTrackPreference(): MusicTrackId {
  try {
    const value = window.localStorage.getItem(MUSIC_TRACK_STORAGE_KEY);
    const found = MUSIC_TRACKS.find((track) => track.id === value);
    return found?.id ?? DEFAULT_MUSIC_TRACK_ID;
  } catch {
    return DEFAULT_MUSIC_TRACK_ID;
  }
}

export function writeMusicTrackPreference(trackId: MusicTrackId): void {
  try {
    window.localStorage.setItem(MUSIC_TRACK_STORAGE_KEY, trackId);
  } catch {
    // localStorage can be unavailable in private mode; the in-memory store still works.
  }
}
